import styles from './style.styl'
import Section from '../section'

const What = () => (
  <Section
    className={styles.what}
    title={`what&nbsp;<br /><span class='alt'>i</span>s&nbsp;<br /><span class='alt'>i</span>t`}
    text={`
          Design Leaders programme is the&nbsp;only MBA equivalent that is made specifically for&nbsp;Creative Directors&nbsp;and&nbsp;Design Leaders&nbsp;with 15+ years of experience who want to get a better understanding of the&nbsp;business processes, become greater leaders and take their career and business internationally.
          <br /><br />
          A 9&#8209;week programme is broken down into 5 intensive modules in London and California — two capitals of design, technology and entrepreneurship.
    `}
  />
)

export default What



// WEBPACK FOOTER //
// ./components/what/index.js